import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import AppSystemTimeProvider from './components/app/AppSystemTimeProvider';
import Ng1CommunicationProvider from './components/app/Ng1CommunicationProvider';
import AppThemeProvider from './components/app/AppThemeProvider';
import AppSnackbarProvider from './components/app/AppSnackbarProvider';
import App from './components/app/App';
import Lingui from './components/lingui/Lingui';

const isDev = process.env.NODE_ENV === 'development';
if (isDev) {
    // Clear console error logs
    const IGNORE_ERROR_LIST = [
        `Warning: ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot`,
        'Support for defaultProps will be removed',
        'findDOMNode is deprecated',
    ];
    // eslint-disable-next-line no-console
    const originalConsoleError = console.error;
    // eslint-disable-next-line no-console,func-names
    console.error = function (...args) {
        const message = args[0];
        if (typeof message === 'string' && IGNORE_ERROR_LIST.some((text) => message.includes(text))) {
            return;
        }
        originalConsoleError.apply(console, args);
    };
}

render(
    <Router>
        <Lingui>
            <Ng1CommunicationProvider>
                <AppSystemTimeProvider>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <AppThemeProvider>
                            <AppSnackbarProvider>
                                <App />
                            </AppSnackbarProvider>
                        </AppThemeProvider>
                    </MuiPickersUtilsProvider>
                </AppSystemTimeProvider>
            </Ng1CommunicationProvider>
        </Lingui>
    </Router>,
    document.getElementById('root')
);
